import { useEffect } from 'react'
import { goToHomePage } from './goToHomePage'

/**
 * Força reload completo do documento em links internos do site público,
 * para que o browser mostre o indicador nativo de carregamento a cada clique.
 */
export function useFullPageNavigation(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined

    const handleClick = (event) => {
      if (event.defaultPrevented) return
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

      const anchor = event.target.closest('a[href]')
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return

      const rawHref = anchor.getAttribute('href')
      if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:')) {
        return
      }

      let url
      try {
        url = new URL(rawHref, window.location.href)
      } catch {
        return
      }

      if (url.origin !== window.location.origin) return

      const next = `${url.pathname}${url.search}${url.hash}`
      const current = `${window.location.pathname}${window.location.search}${window.location.hash}`
      if (next === current) {
        if (url.pathname === '/' && !url.search && !url.hash) {
          goToHomePage(event)
        }
        return
      }

      event.preventDefault()
      event.stopImmediatePropagation()
      window.location.assign(next)
    }

    document.addEventListener('click', handleClick, true)
    return () => document.removeEventListener('click', handleClick, true)
  }, [enabled])
}
